module.exports = __webpack_public_path__ + "img/0-89.ab9f7650.jpg";